import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {PropertyPriceHistoryDTO} from "../types/PropertyPriceHistoryDTO";

export const getPropertyPriceHistoryApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getPropertyPriceHistory: builder.query<PropertyPriceHistoryDTO[], number>({
            query: (propertyId) => ({
                url: apiV2Link.property.priceHistory({propertyId})
            })
        })
    })
});

export const {useGetPropertyPriceHistoryQuery} = getPropertyPriceHistoryApi;
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {PropertyPriceHistoryDTO} from "../types/PropertyPriceHistoryDTO";

export const getPropertyPriceHistoryApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getPropertyPriceHistory: builder.query<PropertyPriceHistoryDTO[], number>({
            query: (propertyId) => ({
                url: apiV2Link.property.priceHistory({propertyId})
            })
        })
    })
});

export const {useGetPropertyPriceHistoryQuery} = getPropertyPriceHistoryApi;
